/**
 * Small status pill (11–12px text, 20px tall). Colour carries meaning:
 * success = done/enabled, warning = needs attention, danger = failed/error,
 * info = in progress, neutral = everything else. Never use it as a button.
 */
import type { ReactNode } from 'react';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand';

export interface StatusPillProps {
  tone?: StatusTone;
  children: ReactNode;
  /** Longer explanation on hover. */
  title?: string;
  className?: string;
}

export function StatusPill({
  tone = 'neutral',
  children,
  title,
  className,
}: StatusPillProps): JSX.Element {
  return (
    <span
      className={`status-pill status-pill--${tone}${className ? ` ${className}` : ''}`}
      title={title}
    >
      {children}
    </span>
  );
}
